import { render, staticRenderFns } from "./IdentityDetail.vue?vue&type=template&id=07a8fd69&"
import script from "./IdentityDetail.vue?vue&type=script&lang=js&"
export * from "./IdentityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports